import gql from "graphql-tag";

export const GET_USERS_LIST = gql`
  subscription chat_message_history(
    $business_user_id: uuid
    $search_text: String
  ) {
    admin_business_last_message_history_view(
      where: {
        reciever_user_id: { _eq: $business_user_id }
        admin_user: { full_name: { _ilike: $search_text } }
      }
      order_by: { sent_at: desc_nulls_last }
    ) {
      message
      message_id
      sender_admin_user_id
      reciever_user_id
      private_chat_description
      seen_at
      sent_at
      admin_user {
        id
        full_name
        profile_photo_path
        profile_photo_url
      }
    }
  }
`;
